import messages from './cmsEditorForm.json' with { type: 'json' };

export const cmsEditorFormEn: Readonly<typeof messages> = messages;
